const INVALID_CONSTITUENT_ID = 1;
const DONOR_NOT_FOUND = 2;
const INVALID_DS_API_KEY = 3;
const INVALID_ADVANCE_API_KEY = 4;
const ORGANIZATION_NOT_FOUND = 5;
export const INCORRECT_FILE_TYPE = 6;
export const FILE_TOO_LARGE = 7;
const INCORRECT_HEADER_INFORMATION = 8;
const BLANK_PRIMARY_ID = 9;
const INVALID_PRIMARY_ID = 10;
const FILE_NOT_FOUND = 11;
const INTEREST_PROCESSING_ERROR = 17;
const RATING_PROCESSING_ERROR = 18;
const ASSET_PROCESSING_ERROR = 19;
const DS_API_ERROR = 510;
export const UNAUTHORIZED = 401;
export const DEFAULT = 500;

export function getUserFriendlyErrorMessage(
    code = DEFAULT,
    message = "",
    extra = null,
    messageOnly = false
  ) {
    code = parseInt(code);
    if (code === INVALID_CONSTITUENT_ID) {
      message = `Invalid constituent ID: ${extra}`;
    } else if (code === DONOR_NOT_FOUND) {
      message =
        "This record was not found in DonorSearch. Please check DonorSearch and try again";
    } else if (code === INVALID_DS_API_KEY) {
      message =
        "DonorSearch API key is not valid. Please speak with your system administrator";
    } else if (code === INVALID_ADVANCE_API_KEY) {
      message =
        "CRM Advance API key is not valid. Please speak with your system administrator";
    } else if (code === ORGANIZATION_NOT_FOUND) {
      message =
        "Your organization was not found in our system. Please check with your system administrator";
    } else if (code === INCORRECT_FILE_TYPE) {
      message = `Incorrect file type. Please select a valid .xlsx or .xls file`;
    } else if (code === FILE_TOO_LARGE) {
      message = "File size is too large. Maximum file size is 25Mb";
    } else if (code === INCORRECT_HEADER_INFORMATION) {
      message =
        "File does not contain correct header information. Please check file contents";
    } else if (code === BLANK_PRIMARY_ID) {
      message = "Primary Id column is empty";
    } else if (code === INVALID_PRIMARY_ID) {
      message = "Primary Id value is invalid";
    } else if (code === FILE_NOT_FOUND) {
      message =
        "File Not Found. Please refresh your screen to get an updated list of files. If the problem persists, please contact your system administrator";
    } else if(code === INTEREST_PROCESSING_ERROR) {
      message = 'Missing Interest Type. Please add all Interest Validations'
    } else if(code === RATING_PROCESSING_ERROR) {
      message = 'Missing Rating Type. Please add all Rating Validations'
    } else if(code === ASSET_PROCESSING_ERROR) {
      message = 'Missing Asset Type. Please add all Asset Validations'
    } else if (code === DS_API_ERROR) {
      message =
        "DonorSearch API error. Please contact your DonorSearch representative";
    } else if(code === UNAUTHORIZED) {
      message = 'Unauthorized. Please speak with your system administrator'
    } else if (code === DEFAULT) {
      message = "Internal Server Error";
    } else {
      message = "Internal Server Error";
    }
    if (messageOnly) return message + ".";
    return `Error Code: ${code} - ${message}.`;
  }
  